import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { loginRequest } from "./authConfig";

function LoginRedirect() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const inProgress = window.localStorage.getItem("msal_progress");

  useEffect(() => {
    if (!isAuthenticated) {
      window.localStorage.setItem("msal_progress", "true");
      instance
        .loginRedirect(loginRequest)
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          window.localStorage.removeItem("msal_progress");
          // window.location.replace("https://weareinbody.com");
        });
    }
  }, [inProgress, isAuthenticated, instance]);

  return <div>loginRedirect</div>;
}

export default LoginRedirect;
